<script>
	export let termGroups = {};
	let activeGroup = 'A';
	function handleActivGroupChange(letter) {
		activeGroup = letter;
	}

	let node;
	let containerHeight;
	$: containerHeight = node?.offsetHeight ?? 0;
	window.onresize = () => (containerHeight = node?.offsetHeight ?? 0);
</script>

<h3 class="filter-section-header">Search by Letter</h3>
<ul class="letters">
	{#each termGroups as termGroup}
		<li>
			<div
				role="button"
				tabindex="0"
				class={termGroup.starts_with == activeGroup ? 'active-term-group' : ''}
				on:click={() => handleActivGroupChange(termGroup.starts_with)}
				on:keydown={() => handleActivGroupChange(termGroup.starts_with)}
			>
				{termGroup.starts_with}
			</div>
		</li>
	{/each}
</ul>
<div
	style="height: {containerHeight}px; overflow: hidden; transition: height 500ms ease;"
>
	{#each termGroups as termGroup}
		{#if termGroup.starts_with == activeGroup}
			<ul class="terms-container" bind:this={node}>
				{#if termGroup.terms.length > 0}
					{#each termGroup.terms as term}
						<li class="term">
							<div class="glossary-preview">
								<a href={term.link} tabindex="0">
									<div class="glossary-card">
										<div class="blog-card-content">
											<h3>{term.title}</h3>
										</div>
									</div>
								</a>
							</div>
						</li>
					{/each}
				{:else}
					<li class="term">
						No glossary terms were found for the letter {activeGroup}
					</li>
				{/if}
			</ul>
		{/if}
	{/each}
</div>
